import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { trim } from 'lodash-es';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-outbound-fax-search-form',
  templateUrl: './outbound-fax-search-form.component.html',
  styleUrls: ['./outbound-fax-search-form.component.scss'],
  imports: [FormsModule, RouterLink]
})
export class OutboundFaxSearchFormComponent implements OnInit {
  canSearch = false;
  claimIdentifier;

  @Output() public faxSearch = new EventEmitter<string>();

  constructor() {}

  ngOnInit() {
    this.updateCanSearch();
  }

  onFormSubmit() {
    this.faxSearch.emit(this.claimIdentifier);
  }

  onClaimIdChange() {
    this.updateCanSearch();
  }

  private updateCanSearch() {
    this.canSearch = !!trim(this.claimIdentifier);
  }
}
